import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  page: 1,
  itemsPerPage: 10,
};

const cancellationsSlice = createSlice({
  name: 'cancellationsUI',
  initialState,
  reducers: {
    setPage: (state, action) => {
      state.page = action.payload;
    },
    setItemsPerPage: (state, action) => {
      state.itemsPerPage = action.payload;
    },
    resetFilters: () => initialState,
  },
});

export const { setPage, setItemsPerPage, resetFilters } = cancellationsSlice.actions;
const allCancellationsReducer = cancellationsSlice.reducer;
export default allCancellationsReducer;
